import { Badge, Breadcrumb, Button, Calendar, Checkbox, Col, DatePicker, Divider, Drawer, Dropdown, Flex, Form, Input, InputNumber, Layout, Radio, Row, Select, Space, Table, Tag, TimePicker, theme } from 'antd';
import {
    SendOutlined,
    MoreOutlined,
    MessageOutlined,
    UnlockOutlined,
    EyeOutlined,
    LockOutlined,
    EditOutlined
} from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react'
import TextArea from 'antd/es/input/TextArea';

const { Search } = Input;
const { Header, Sider, Content } = Layout;


const options = [
    {
        label: 'After Meeting',
        value: 'after',
    },
    {
        label: 'Custom Timing',
        value: 'custom',
    },
];
export default function VotingEnd({ setVotingData }) {

    // useEffect(() => {
    //     console.log("___allowVoting :", props.allowVoting ? props.allowVoting : false)
    // }, [props.allowVoting])

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    const [value, setValue] = useState('Never');
    const [showTextArea, setShowTextArea] = useState(false);
    const [customDate, setCustomDate] = useState(null);
    const [customTime, setCustomTime] = useState(null);

    const onChange = ({ target: { value } }) => {
        // console.log('radio checked', value);
        setValue(value);
        setVotingData({
            isEnabled: true,
            end: {
                type: value,
                customDate: value === 'custom' ? customDate?.format('YYYY-MM-DD') : null,
                customTime: value === 'custom' ? customTime?.format('HH:mm') : null,
            }
        })
    };

    const onDateChange = (date) => {
        setCustomDate(date);
        setVotingData({
            isEnabled: true,
            end: {
                type: value,
                customDate: date?.format('YYYY/MM/DD'),
                customTime: customTime?.format('HH:mm'),
            }
        });
    };
    const onTimeChange = (time) => {
        setCustomTime(time);
        setVotingData({
            isEnabled: true,
            end: {
                type: value,
                customDate: customDate?.format('YYYY/MM/DD'),
                customTime: time?.format('HH:mm'),
            }
        });
    };

    const onChangeSignatory = (e) => {
        setShowTextArea(e.target.checked)
    };

    return (
        <>
            <Form>
                <Form.Item>
                    <Radio.Group options={options} onChange={onChange} value={value} optionType="button" />
                </Form.Item>
                <br />

                {value === 'custom' && (
                    <Row>
                        <Col span={12}>
                            <Form.Item label='Select Date'>
                                <DatePicker onChange={onDateChange} />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item label='Select Time'>
                                <TimePicker onChange={onTimeChange} />
                            </Form.Item>
                        </Col>
                    </Row>
                )}
            </Form>

        </>
    )
}